/**
 * @file
 * Attaches is useful rating.
 */

(function ($, Drupal) {
  Drupal.behaviors.usefulRating = {
    attach: function (context, settings) {
      $("body")
        .find(".useful")
        .each(function () {
          var $this = $(this);
          $(once("processed", "select", context)).each(function () {
            $this.find("[type=submit]").hide();
            var $select = $(this);
            $select
              .after(
                '<div class="useful-rating"><a href="#"><span class="visually-hidden">Thumbs Up</span><i class="thumbs-up"></i></a><a href="#"><span class="visually-hidden">Thumbs Down</span><i class="thumbs-down"></a></i></div>'
              )
              .hide();
            $this
              .find(".useful-rating a")
              .eq(0)
              .each(function () {
                $(this).bind("click", function (e) {
                  e.preventDefault();
                  $select.get(0).selectedIndex = 0;
                  $this.find("[type=submit]").trigger("click");
                  $this.find("a").addClass("disabled");
                  $(".blog-rating").html(
                    "Thank you! We appreciate your feedback."
                  );
                });
              });

            $this
              .find(".useful-rating a")
              .eq(1)
              .each(function () {
                $(this).bind("click", function (e) {
                  e.preventDefault();
                  $select.get(0).selectedIndex = 1;
                  $this.find("[type=submit]").trigger("click");
                  $this.find("a").addClass("disabled");
                  $(".blog-rating").html(
                    "Thank you! We appreciate your feedback."
                  );
                });
              });
          });
        });
    },
  };
})(jQuery, Drupal, once);
